module.exports = __webpack_public_path__ + "img/yano_Q_400_15_5.9e6ca83b.png";